import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}
const routes: RouteRecordRaw = {
  path: '/regimental_commander',
  component: Layout,
  meta: {
    title: '合同管理',
    icon: 'welfare',
  },
  children: [
    {
      path: '',
      component: () => import('@/views/regimental_commander/index.vue'),
      meta: {
        title: '合同管理',
        menu: false,
        breadcrumb: false,
          auth: [
             'RegimentalCommander.RegimentalCommander.menu'
         ]
      }
    },
    {
      path: 'detail/:id',
      name: 'regimentalCommanderDetail',
      component: () => import('@/views/regimental_commander/detail.vue'),
      meta: {
        title: '合同详情',
        menu: false,
        activeMenu: '/regimental_commander',
        auth: [
            'RegimentalCommander.RegimentalCommander.menu'
        ]
      },
    },
  ],
}
export default routes

